<script setup lang="ts">
import { computed } from 'vue'
import { useScreensaverStore } from '@/stores/screensaver/screensaverStore'
import type { STScreensaverProps } from '@/types/STScreensaverProps'

// macros
const { url, mediaSource } = defineProps<STScreensaverProps>()

// composables
const { hideScreensaver } = useScreensaverStore()

// computeds
const screensaverMediaStyles = computed(() => {
  return {
    backgroundImage: `url(${url})`
  }
})

const isIframeMediaSource = computed(() => mediaSource === 'Link')

const isImageMediaSource = computed(() => mediaSource === 'Upload')
</script>

<template>
  <div class="st-screensaver">
    <iframe v-if="isIframeMediaSource" class="st-screensaver__iframe" :src="url" />
    <div
      v-else-if="isImageMediaSource"
      class="st-screensaver__image"
      :style="screensaverMediaStyles"
    />
    <div
      class="st-screensaver__overlay"
      @touchstart="hideScreensaver"
      @mousedown="hideScreensaver"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@nsftx/seven-nxg-design-system/style/mixins' as mixins;

.st-screensaver {
  position: fixed;
  inset: 0;
  @include mixins.zindex(notification, 3);

  &__iframe,
  &__image,
  &__overlay {
    position: absolute;
    inset: 0;
  }

  &__iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
  &__image {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &__overlay {
    background: transparent;
  }
}
</style>
